import { useCallback } from 'react';

export const useEventCallback = (callback) =>
    useCallback((event) => callback(event.target.value), [callback]);
